
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/private-booking",
      function () {
        return require("private-next-pages/private-booking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/private-booking"])
      });
    }
  